$.fn.loop_prev = function(index) {
  let $original = $(this), $element = $original
  if (!index) index = 1
  for (let i = 0; i < index; i++) {
    $element = $element.prev()
    if (!$element.length) {
      $element = $original.parent().find('>:last-child')
    }
  }
  return $element
}

$.fn.loop_next = function(index) {
  let $original = $(this), $element = $original
  if (!index) index = 1
  for (let i = 0; i < index; i++) {
    $element = $element.next()
    if (!$element.length) {
      $element = $original.parent().find('>:first-child')
    }
  }
  return $element
}
